import React, {useState} from 'react';
import styles from './pcode-generation-modal-content.module.scss';
import {Button, Col, Row, Spinner} from "react-bootstrap";
import SecurityService from "../../../../../../services/security-service";

const PCodeGenerationModalContent = ({securityId, entityId, onClose}) => {
  const [loading, setLoading] = useState(false);
  const [pCodePrefix, setPCodePrefix ] = useState("");
  const securityService = new SecurityService();

  const onInputChange = (e) => {
    setPCodePrefix(e.target.value);
  }

  const patchId = async () => {
    const _ = await securityService.patchOrdersId('PARTICIPANT_CODE', securityId, entityId, pCodePrefix);
    setLoading(false);
    onClose();
    window.location.reload();
  }

  const generate = () => {
    setLoading(true);
    try {
      patchId();
    }catch(error){}
  }
  return (
    <div className={styles['p-code-generation']}>
      <Row>
        <Col lg={12}>
          <div className={styles['bp-id-input']}>
            <input type="text" placeholder="XXXXXXXXXXX" maxLength={"11"} onChange={onInputChange}/>
          </div>
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col lg={6}>
          <div className={styles['generate-button']}>
            <Button disabled={loading} onClick={() => generate()}>
              {loading ? <Spinner size="sm" animation="border"/> : 'GENERATE'}
            </Button>
          </div>
        </Col>
        <Col lg={6}>
          <div className={styles['cancel-button']}>
            <Button variant="secondary" onClick={() => onClose()}>CANCEL</Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default PCodeGenerationModalContent;
